module.exports = __webpack_public_path__ + "Roboto-Light.46e48ce0628835f68a73.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Light.ttf
// module id = 460
// module chunks = 2